exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/core-js/library/modules/_object-gops.js
// module id = 132
// module chunks = 0